import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { FieldErrorContext } from "react-aria-components";
import { jsx as _jsx } from "react/jsx-runtime";
const StyleContext = /*#__PURE__*/React.createContext({
  style: "modern",
  defaultLabelStyle: "default"
});
export const StyleProvider = t0 => {
  const $ = _c(5);
  const {
    defaultLabelStyle: t1,
    children
  } = t0;
  const defaultLabelStyle = t1 === undefined ? "default" : t1;
  let t2;
  let t3;
  if ($[0] !== defaultLabelStyle) {
    t3 = {
      style: "modern",
      defaultLabelStyle
    };
    $[0] = defaultLabelStyle;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  t2 = t3;
  const value = t2;
  let t4;
  if ($[2] !== children || $[3] !== value) {
    t4 = /*#__PURE__*/_jsx(StyleContext.Provider, {
      value: value,
      children: children
    });
    $[2] = children;
    $[3] = value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};

/**
 * @deprecated We've removed the legacy style, so this hook is no longer needed.
 */
// eslint-disable-next-line @eslint-react/hooks-extra/no-unnecessary-use-prefix
export function useStyle() {
  return "modern";
}
export function useDefaultLabelStyle() {
  const {
    defaultLabelStyle
  } = React.useContext(StyleContext);
  return defaultLabelStyle;
}
export function useNullableContext(context) {
  return React.useContext(context);
}
export function useFieldErrorContext() {
  return useNullableContext(FieldErrorContext);
}
//# sourceMappingURL=context.js.map